__turbopack_context__.v({
  "link": "iPPgoa_link",
  "submenuItem": "iPPgoa_submenuItem",
  "submenuItemactive": "iPPgoa_submenuItemactive",
  "text": "iPPgoa_text",
});
